module.exports = __webpack_public_path__ + "phone.svg?451da31dffcd5efc3190bd481ef3601a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.svg
// module id = 77
// module chunks = 6